import { useMemo, useEffect, useState } from 'react';
import { useActiveAnalysis } from '../../services/api/KeynomeAPIHooks';

export const useCanUpload = (samples, sampleName) => {
  const [canUpload, setCanUpload] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const sample = useMemo(() => {
    if (!samples) return null;
    return samples.find((s) => s.attributes.sample_name === sampleName);
  }, [samples, sampleName]);
  
  const { data: analysis, isLoading: analysisLoading } = useActiveAnalysis(sample?.id);
  
  useEffect(() => {
    if (samples == null || analysisLoading) {
        return;
      }
  
    if (!sample || !analysis) {
        setCanUpload(true);
        setIsLoading(false);
        return;
    }
  
    const blockingStates = ['analyzing', 'completed', 'failed', 'delayed', 'succeeded'];
    const status = analysis.attributes?.status;
  
    setCanUpload(!blockingStates.includes(status));
    setIsLoading(false);
  }, [sample, analysis, samples, analysisLoading]);

  return { canUpload, isLoading };
};